import React from 'react';
import { Link } from 'react-router-dom';

function DashboardFooter() {
  return (
    <footer className="dashboard-footer">
      <div className="dashboard-footer-left">
        <Link to="/terms" className="dashboard-footer-link">Terms & Conditions</Link>
        <span className="dashboard-footer-separator">|</span>
        <Link to="/privacy" className="dashboard-footer-link">Privacy</Link>
        <span className="dashboard-footer-separator">|</span>
        <Link to="/release-notes" className="dashboard-footer-link">Release Notes</Link>
      </div>
      <div className="dashboard-footer-right">
        © 2026 All rights reserved. Begin the Work, LLC
      </div>
    </footer>
  );
}

export default DashboardFooter;

